export default __webpack_public_path__ + "static/media/dp-logo.f758588b.png";